<template>
  <a-modal
    title="创建访客预约申请单"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleSubmit"
    @cancel="() => { $emit('onClose') }"
  >
    <a-form
      :form="form"
      ref="applyForm"
      v-bind="formLayout"
    >
      <a-tabs :default-active-key="tabIndex" @change="tabChange">
        <a-tab-pane key="1" tab="基础信息">
          <a-form-item label="被拜访人" required>
            <span style="margin-right: 10px">{{ peopleName }}</span>
            <a-input v-decorator="['beVisitedPersonId', {rules:[{required: true, message: '请选择被拜访人'}]}]" hidden
                     placeholder="请选择被拜访人"/>
            <a-button type="primary" size="small" @click="handlePeopleSearchShow">选择</a-button>
          </a-form-item>
          <a-form-item label="拜访时间" required>
            <a-range-picker
              dropdownClassName="form-date-picker"
              :getCalendarContainer="trigger => trigger.parentNode"
              style="width: 100%"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="[$t('identificationRecord.startTimeTxt'), $t('identificationRecord.endTimeTxt')]"
              v-decorator="['dateRange', {initialValue: [moment(),  moment().add(1, 'days')],rules:[{required: true, message: '访问时间不能为空'}]}]"
              :disabledDate="c => c && c < moment().subtract(1, 'days').endOf('day')"
            />
          </a-form-item>
          <a-form-item label="来访事由" required>
            <a-input v-decorator="['reason', {rules:[{required: true, message: '来访事由不能为空'}]}]"
                     placeholder="请输入"/>
          </a-form-item>
          <a-form-item label="随行人数" :required="isOnlyMain">
            <a-input-number style="width: 100%" v-decorator="['entourageAmount', {initialValue: 0}]" suffix="人"/>
          </a-form-item>
          <a-form-item label="备注">
            <a-textarea v-decorator="['remark', {initialValue: ''}]"></a-textarea>
          </a-form-item>

         </a-tab-pane>
        <a-tab-pane key="2" tab="扩展信息" force-render>
          <template v-for="(item, index) in exFieldConfig" >
            <!-- text -->
            <a-form-item v-if="item.type === 1 && !item.valid.isTextArea" :label="item.name" :required="!item.valid.allowEmpty">
              <a-input v-decorator="[`customExFieldValue[${item.id}]`, {initialValue: item.defaultValue,
            rules:[
              {required: !item.valid.allowEmpty, message: `${item.name} 不能为空`},
              {max: item.valid.maxLength, message: `${item.name} 最大长度${item.valid.maxLength}`}
            ]}]"/>
            </a-form-item>
            <!-- text -->
            <a-form-item v-if="item.type === 1 && item.valid.isTextArea" :label="item.name" :required="!item.valid.allowEmpty">
              <a-textarea v-decorator="[`customExFieldValue[${item.id}]`, {initialValue: item.defaultValue,rules:[{required: !item.valid.allowEmpty, message: `${item.name}不能为空`}]}]"/>
            </a-form-item>
            <!-- number -->
            <a-form-item v-if="item.type === 2" :label="item.name" :required="!item.valid.allowEmpty">
              <a-input-number
                :max="item.valid.max"
                :min="item.valid.min"
                style="width: 100%"
                :precision="item.valid.precision"
                v-decorator="[`customExFieldValue[${item.id}]`, {
                initialValue: item.defaultValue,
                rules:[
                  {required: !item.valid.allowEmpty, message: `${item.name}不能为空`}
                ]}
              ]"/>
            </a-form-item>
            <!-- switch -->
            <a-form-item v-if="item.type === 3" :label="item.name" :required="!item.valid.allowEmpty">
              <a-switch v-decorator="[`customExFieldValue[${item.id}]`, {initialValue: item.defaultValue,rules:[{required: !item.valid.allowEmpty, message: `${item.name}不能为空`}]}]" :checked="item.defaultValue"/>
            </a-form-item>
            <!-- 单选 -->
            <a-form-item v-if="item.type === 6" :label="item.name" :required="!item.valid.allowEmpty">
              <a-radio-group v-decorator="[`customExFieldValue[${item.id}]`, {initialValue: item.defaultValue,rules:[{required: !item.valid.allowEmpty, message: `${item.name}不能为空`}]}]">
                <a-radio v-for="i in item.enums" :key="i.code" :value="i.code">{{i.name}}</a-radio>
              </a-radio-group>
            </a-form-item>
            <!-- 多选 -->
            <a-form-item v-if="item.type === 7" :label="item.name" :required="!item.valid.allowEmpty">
              <a-checkbox-group v-decorator="[`customExFieldValue[${item.id}]`, {initialValue: item.defaultValue,rules:[{required: !item.valid.allowEmpty, message: `${item.name}不能为空`}]}]">
                <a-checkbox v-for="i in item.enums" :key="i.code" :value="i.code"> {{i.name}} </a-checkbox>
              </a-checkbox-group>
            </a-form-item>
            <a-form-item v-if="item.type === 401" :label="item.name" :required="!item.valid.allowEmpty">
              <a-date-picker
                format="YYYY-MM-DD"
                style="width: 100%"
                placeholder="请选择日期"
                v-decorator="[`customExFieldValue[${item.id}]`, {initialValue: item.defaultValue || moment(),rules:[{required: !item.valid.allowEmpty, message: `${item.name}不能为空`}]}]"
              />
            </a-form-item>
            <!-- datetime -->
            <a-form-item v-if="item.type === 403" :label="item.name" :required="!item.valid.allowEmpty">
              <a-date-picker
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                dropdownClassName="form-date-picker"
                :getCalendarContainer="trigger => trigger.parentNode"
                style="width: 100%"
                placeholder="请选择时间日期"
                v-decorator="[`customExFieldValue[${item.id}]`, {initialValue: item.defaultValue || moment(),rules:[{required: !item.valid.allowEmpty, message: `${item.name}不能为空`}]}]"
              />
            </a-form-item>
          </template>
        </a-tab-pane>
        <a-tab-pane key="3" tab="人员信息">
          <a-form-item label="人员信息" required>
            <a-upload
              name="file"
              accept=".xlsx,.xls"
              :multiple="false"
              :fileList="fileList"
              :customRequest="uploadFile"
            >
              <a-button>
                <a-icon :type="uploadFileLoading ? 'loading' : 'upload'"/>
                上传访客人员信息
              </a-button>
            </a-upload>
          </a-form-item>
          <a-form-item :label="$t('personalMana.improtInstructions')">
            <a download="导入访客信息模板.xlsx" :href="path + '导入访客信息模板.xlsx'" target="_blank">访客人员信息请下载《导入访客信息模板.xlsx》</a>
          </a-form-item>
          <a-table
            :columns="tableColumns"
            :dataSource="tableData"
            :pagination="false"
            :loading="loading"
            :rowKey="record=>record.phoneNumber"
          >
        <span slot="scenePhotoUrl" slot-scope="text, record">
          <a-upload
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :data="{phone: record.phoneNumber}"
            :show-upload-list="false"
            :customRequest="handleUploadChange"
          >
          <img v-if="imageUrl.hasOwnProperty(record.phoneNumber) && imageUrl[record.phoneNumber]"
               :src="imageUrl[record.phoneNumber]" alt="avatar"/>
          <div v-else>

            <a-icon
              :type=" imgUploading.hasOwnProperty(record.phoneNumber) && imgUploading[record.phoneNumber]? 'loading' : 'plus'"/>
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
        </span>
            <span slot="action" slot-scope="text, record">
          <template>
          <a @click="() => handlerDetailRemove(record)" class="text-danger">删除</a>
          </template>
        </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-form>
    <a-drawer
      width="400"
      placement="right"
      :visible="peopleSearchVisible"
      @close="onPeopleSearchClose"
    >
      <div class="content-warp">
        <div class="content-panle bg-white">
          <div class="table-operation-area">
            <div class="btn-area-inline">人员查询</div>
            <a-form
              class="search-form"
              layout="inline"
              :form="listSearchForm"
              @submit.prevent="handleSearchList"
            >
              <a-form-item>
                <a-input
                  style="width: 180px"
                  type="text"
                  v-decorator="['name']"
                  :placeholder="'请输入人员姓名'"
                >
                  <a-icon
                    slot="prefix"
                    type="search"
                    style="color:rgba(0,0,0,.25)"
                  />
                </a-input>
              </a-form-item>

              <a-form-item style="margin-right:0">
                <a-button type="primary" html-type="submit" style="margin-right: 10px" :loading="loading">{{
                    $t('visitorMana.reserved.searchBtn')
                  }}
                </a-button>
              </a-form-item>
            </a-form>
          </div>
          <!-- 列表 -->
          <a-table
            :columns="peopleColumns"
            :dataSource="peopleList"
            :pagination="false"
            :loading="peopleSearchLoading"
            :rowKey="record=>record.id"
          >
            <template slot="name" slot-scope="text, record">
              <span @click="peopleRowClick(record)" style="display: inline-block; width: 100%; height: 100%">{{ text }}</span>
            </template>
          </a-table>
        </div>
      </div>
     </a-drawer>
  </a-modal>
</template>
<script>
import moment from 'moment'
import * as xlsx from 'xlsx'
import { compressImageFile } from '../../../utils/utils'
import { uploadBase64Img } from '@/api/fileUpload'
import { listPerson } from '../../../api/personalMana'
import { getUserConfig } from '@/api/userMana'
import { importAppointmentApply } from '../../../api/reserveMana'
//生成访客预约申请记录弹框
export default {
  name: 'CreateAppointmentModel',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const formLayout = {
      labelCol: {
        xs: { span: 20 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 20 },
        sm: { span: 12 }
      }
    }
    return {
      path: process.env.BASE_URL,
      tabIndex: '1',
      fileList: [],
      loading: false,
      uploadFileLoading: false,
      form: this.$form.createForm(this),
      listSearchForm: this.$form.createForm(this),
      formLayout,
      tableColumns: this.getColumns(),
      activeKey: 1,
      sourceData: [],
      tableData: [],
      imgUploading: {},
      chooseUserPhone: '',
      imageUrl: {},

      confirmLoading: false,
      peopleList: [],
      peopleSearchVisible: false,
      peopleSearchLoading: false,
      peopleName: "",
      peopleColumns: [{
        title: '姓名',
        dataIndex: 'name',
        scopedSlots: { customRender: 'name' }
      }],
      exFieldConfig:{},
      needIdNumber: false,
      isOnlyMain: false,
      isAppointmentVisitorScenePhotoNotEmpty: false
    }
  },
  watch:{
    visible(val){
      if (val){
        this.getSettings()
      }
    }
  },
  mounted() {},
  methods: {
    moment,
    async getSettings(){
      let _this = this
      try {
        const res = await getUserConfig()
        const {
          appointmentApplyCustomExFieldConfig,
          isAppointmentVisitorIdNumberNotEmpty,
          isOnlyMainAppointmentVisitor,
          isAppointmentVisitorScenePhotoNotEmpty
        } = res.data.collection[0]
        let exFieldConfig = {}
        if (appointmentApplyCustomExFieldConfig){
          let exFields = JSON.parse(appointmentApplyCustomExFieldConfig)
          exFields.forEach(item=>{
            exFieldConfig[item.id] = item
          })
        }
        _this.exFieldConfig = exFieldConfig
        _this.needIdNumber = isAppointmentVisitorIdNumberNotEmpty === 'true'
        _this.isOnlyMain = isOnlyMainAppointmentVisitor === 'true'
        _this.isAppointmentVisitorScenePhotoNotEmpty = isAppointmentVisitorScenePhotoNotEmpty === 'true'
      }catch (e) {

      }
    },
    handleSubmit() {
      //isAppointmentVisitorScenePhotoNotEmpty  是否必须头像

      let _this = this
      let phoneReg = /^[1][3-9][0-9]{9}$/
      let idNumberReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      this.form.validateFields((err,value) => {
        if (!err) {
          try {
            //验证人员信息
            let params = JSON.parse(JSON.stringify(value))
            let appointmentVisitors = _this.tableData
            if (appointmentVisitors.length === 0){
              throw new Error("请上传人员信息")
            }
            for (let i = 0; i < appointmentVisitors.length; i++) {
              let item = appointmentVisitors[i]
              if (!item.name){
                throw new Error(`第 ${i+1} 位访客【姓名】不能为空`)
              }
              if (!item.phoneNumber){
                throw new Error(`第 ${i+1} 位访客【手机号】不能为空`)
              }
              if (!phoneReg.test(item.phoneNumber)){
                throw new Error(`第 ${i+1} 位访客【手机号】格式错误`)
              }
              if (_this.isAppointmentVisitorScenePhotoNotEmpty && !item.scenePhotoUrl){
                throw new Error(`第 ${i+1} 位访客【现场照】不能为空`)
              }
              console.log(_this.needIdNumber, !idNumberReg.test(item.idNumber))
              if (_this.needIdNumber && !idNumberReg.test(item.idNumber)) {
                throw `第 ${i + 1} 位访客【身份证号】不正确`
              }
            }
            // 深度拷贝
            let customExFieldValue = params.customExFieldValue
            for (const index in customExFieldValue) {
              let item = customExFieldValue[index]
              //查询配置
              if (_this.exFieldConfig.hasOwnProperty(index)){
                let config = _this.exFieldConfig[index]
                if(config.type === 2 && config.valid.precision>0  && item >0){
                  customExFieldValue[index] = parseFloat(item+ '').toFixed(config.valid.precision)
                }
                if (config.type === 401){
                  customExFieldValue[index] = moment(new Date(item)).format('YYYY-MM-DD')
                }
                if (config.type === 403){
                  customExFieldValue[index] = moment(new Date(item)).format('YYYY-MM-DD HH:mm:ss')
                }
              }
            }
            let times  = params.dateRange
            params.appointmentStart = moment(new Date(times[0])).format("YYYY-MM-DD HH:mm:ss")
            params.appointmentEnd = moment(new Date(times[1])).format("YYYY-MM-DD HH:mm:ss")
            params.appointmentVisitors = appointmentVisitors
            delete params.dateRange
            _this.confirmLoading = true
            importAppointmentApply(params).then(res1=>{
              _this.confirmLoading = false
              if (res1 && res1.data.success){
                this.$emit('submit')
              }else{
                throw new Error(res1.data.message)
              }
            }).catch(()=>{})
            // this.$emit('submit', this.form)
          } catch (e) {
            this.$notification.error({ message: e.message, duration: 2 })
          }
        }else{
          let keys = Object.keys(err)
          keys.forEach(key=>{
            let err1 = err[key].errors
            console.log(err1)
            for (let i = 0; i < err1.length; i++) {
              _this.$notification.error({message: err1[i].message})
            }
          })
        }
      })
    },
    getColumns() {
      return [
        {
          title: '姓名',
          dataIndex: 'name'
        },
        {
          title: '证件号码（身份证)',
          dataIndex: 'idNumber'
        },
        {
          title: '电话',
          dataIndex: 'phoneNumber'
        },
        {
          title: '现场照',
          dataIndex: 'scenePhotoUrl',
          scopedSlots: { customRender: 'scenePhotoUrl' },
          width: '200'
        },
        {
          title: '车牌号',
          dataIndex: 'carNumber',
          width: '150'
        },
        {
          title: this.$t('devicesManaActiveTime.listDeviceOperation'),
          dataIndex: 'action',
          fixed: 'right',
          width: '80',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    uploadFile(info) {//上传文件
      let file = info.file
      const isJpgOrPng = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isJpgOrPng) {
        this.$message.error('请选择xlsx类型文件')
        return
      }
      this.fileList = [file]
      this.uploadFileLoading = true
      this.importfile(file)
    },
    //核心函数
    importfile(obj) {
      const _this = this
      const fileReader = new FileReader()
      _this.tableData = []
      _this.columns = []
      fileReader.readAsBinaryString(obj)//需要传blob类型
      fileReader.onload = async (ev) => {
        let res = ev.target.result
        const worker = xlsx.read(res, { type: 'binary' })
        // 将返回的数据转换为json对象的数据
        let reader = xlsx.utils.sheet_to_json(worker.Sheets[worker.SheetNames[0]], {
          header: 1,
          defval: ''
        })
        const ItemType = reader[1][0]
        if (reader && reader.length > 2 && ItemType === '姓名*') {
          reader.splice(0, 2)
        }
        let data = []
        for (let i = 0; i < reader.length; i++) {
          let item = reader[i]
          let name = item[0]
          let phoneNumber = item[1]
          let idNumber = item[2]
          let carNumber = item[3]
          let scenePhotoUrl = ''
          let orderNumber = i
          if (!name && !phoneNumber ){
            continue
          }
          data.push({
            name,
            phoneNumber,
            idNumber,
            orderNumber,
            carNumber,
            scenePhotoUrl
          })
        }
        _this.tableData = data
        _this.uploadFileLoading = false
      }
    },

    // 提交图片前，验证图片大小和宽高，不符合就进行图片压缩
    async handleBeforeUploadImg(file) {
      // console.log('--handleBeforeUploadImg--', file)
      let options = file.type === 'image/gif' ? { maxSize: null } : {
        maxSize: 300,
        fixedW: 375,
        fixedH: 200
      }
      await compressImageFile(file, options, this.handleUploadUserImg)
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject()
    },

    // 上传 Banner 图片
    async handleUploadUserImg(image) {
      try {
        let imageUrl = image.base64
        this.imgUploading[this.chooseUserPhone] = true
        const base64Unhead = image.base64.replace(/^data:image\/\w+;base64,/, '')
        let type = image.type.replace('image/', '')
        type = type === 'jpeg' ? 'jpg': type
        const res = await uploadBase64Img({
          data: base64Unhead,
          suffix: type
        })
        this.imgUploading[this.chooseUserPhone] = false
        this.$message.success(
          `${image.name} ${this.$t('userCenter.uploadSuccess')}`
        )
        this.imageUrl[this.chooseUserPhone] = imageUrl
        let tableData = this.tableData
        tableData.forEach((item, index) => {
          if (item.phoneNumber === this.chooseUserPhone) {
            item.scenePhotoUrl = res.data.collection[0]
          }
        })
        this.tableData = tableData
        //返回的url 加入到人员列表中
      } catch (error) {
        this.$message.error(`${image.name} ${this.$t('userCenter.uploadFail')}`)
        this.imgUploading[this.chooseUserPhone] = false
      }
    },
    handleUploadChange(info) {
      try {
        new Promise((resolve, reject)=>{
          this.chooseUserPhone = info.data.phone
          if (this.imageUrl.hasOwnProperty(this.chooseUserPhone)) {
            this.imageUrl[this.chooseUserPhone] = ''
          }
          this.handleBeforeUploadImg(info.file)
        })
      } catch (e) {
        console.log(e)
      }
    },
    handlePeopleSearchShow() {
      this.getListData("")
      this.peopleSearchVisible = true
    },
    onPeopleSearchClose() {
      this.peopleSearchVisible = false
    },
    // 搜索列表
    async handleSearchList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          this.getListData(values.name)
        }
      })
    },
    async getListData(name){
      try {
        this.peopleSearchLoading = true
        const res = await listPerson({name: name })
        if(res){
          this.peopleList = res.data.collection
        }
        this.peopleSearchLoading = false
      }catch (err) {
        console.log(err)
        this.peopleSearchLoading = false
      }
    },
    peopleRowClick(e){
      this.peopleName = e.name
      this.form.setFieldsValue({"beVisitedPersonId": e.id})
      this.onPeopleSearchClose()
    },
    handlerDetailRemove(data){
      let phone = data.phoneNumber
      let tableData = this.tableData
      tableData.forEach((item,index)=>{
        if (item.phoneNumber === phone){
          tableData.splice(index, 1)
        }
      })
      this.tableData = tableData
    },
    afterHideEditModal() {
      this.confirmLoading = false
      this.$refs.applyForm.resetFields()
    },
    tabChange(e){
      this.tableIndex = e
    },
  },
}
</script>

<style scoped>
.ant-form-item {
  margin-bottom: 6px;
}

.ant-upload.ant-upload-select-picture-card {
  width: 80px !important;
  height: 80px !important;
  margin: 0 !important;
}

.avatar-uploader .ant-upload-select-picture-card img {
  width: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

 .content-warp {
   top: 48px;
 }
</style>
